jQuery($ => {
    class Select {
      constructor(element) {
        this._         = element;
        this._element  = $(element);
        this._trigger  = this._element.find('.m-dropdown__trigger');
        this._content  = this._element.find('.m-dropdown__content');
        this._hasLinks = this._element.hasClass('m-select-custom--links');

        this._options = this._element.find('.m-select-custom__options');
        this._option  = this._options.find('.m-select-custom__option');
        this._native  = this._element.find('.m-select-custom__native');

        this._triggerText = this._element.find('.m-dropdown__text');


        this._defaultAria = this._trigger.data('default-aria');
        this._placeholder = this._trigger.data('placeholder');

        this._selectedOption = this._options.find('.m-select-custom__option--selected');
        this._selectedLabel  = this._selectedOption ? this._selectedOption.textContent: null;
        this._selectedValue  = this._selectedOption ? this._selectedOption.val():       null;

        this._details = {
            selected: {
                label  : this._selectedLabel,
                value  : this._selectedValue,
                target : this._options.find('.m-select-custom__option--selected')[0]
            }
        }
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._element.on('open', this.handleOpen);
        this._element.on('triggerKeydown', this.handleTriggerKeydown);

        this._option.each((_, option) => {
          $(option).on('mousedown', event => {
              this.handleOptionMousedown(event, option);
          });

          $(option).on('keydown', event => {
              this.handleOptionKeydown(event, option);
          });
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Trigger
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateTrigger = isReset => {
        let ariaLabel = this._defaultAria;
        let value;

        if (isReset) {
          value = this._placeholder;
        } else {
          const position = Array.from(this._option).indexOf(this._selected[0]) + 1;
          const count    = this._option.length;
          
          value     = this._selectedLabel;
          ariaLabel = `${ariaLabel}, ${value} Selected, ${position} of ${count}`;

          if (value) {
            this._element.addClass('m-dropdown--value');
          } else {
            this._element.removeClass('m-dropdown--value');
          }
        }

        this._triggerText.text(value);
        this._trigger.attr('aria-label', ariaLabel);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Option
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateOption = (option, isSelected) => {
        if (isSelected) {
          $(option).addClass('m-select-custom__option--selected');
          $(option).attr('aria-selected', 'true');
        } else {
          $(option).removeClass('m-select-custom__option--selected');
          $(option).attr('aria-selected', 'false');
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Native Select
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateNativeSelect = value => {
        this._native.value = this._selectedValue;

        this._native.children().each((_, option) => {
          $(option).attr('selected', false);
          if($(option).attr('value') == value) $(option).attr('selected', true);
        });

        this._native.trigger('change');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Find Option
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      findOption = query => {
        const queryText = query.trim().toLowerCase();
  
        const results = Array.from(this._option).filter(option => {
            const text = option.textContent.trim().toLowerCase();
            return text.indexOf(queryText) === 0;
        });

        return results[0];
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Details
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateDetails = () => {
        this._details = {
            selected: {
                label : this._selectedLabel,
                value : this._selectedValue,
                target: this._options.find('.m-select-custom__option--selected')[0]
            }
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reset
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReset = () => {
        this._selected = null;
        const placeholder = this._trigger.data('placeholder');

        if (placeholder) {
          this._element.addClass('a-select--unset');
          this._native.value = '';
          this._selectedLabel = null;
          this._selectedValue = null;

          this.updateDetails();

          this._option.each((index) => {
            this.updateOption(this._option[index], false);
          });

          this.updateTrigger(true);

          this._element.trigger('reset', {
            details: this._details
          })
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Open
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOpen = () => {
        if (this._selected) {
          this._selected.focus();
        } else {
          this._option[0].focus();
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Select
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionSelect = option => {
        this._selected      = $(option);
        this._selectedLabel = option.textContent;
        this._selectedValue = option.dataset.value;

        this._element.removeClass('m-select-custom--unset');

        this._option.each((index) => {
          this.updateOption(this._option[index], false);
        });

        this.updateOption(option, true);
        this.updateTrigger();
        this.updateNativeSelect(this._selectedValue);

        this.updateDetails();

        this._element.dropdown('handleClose');

        this._element.trigger('change', this._details);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Mousedown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionMousedown = (event, option) => {
        if (this._hasLinks) {
          setTimeout(() => {
            this._element.dropdown('handleClose');
          }, 1000);
        } else {
          event.preventDefault();
          this.handleOptionSelect(option);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionKeydown = (event, option) => {
        this._element.trigger('optionKeydown', {
          option,
          event,
          key: event.key
        });

        switch (event.key) {
          case "Enter":
            if (!this._hasLinks) {
              event.preventDefault();
              this.handleOptionSelect(option);
            }

            setTimeout(() => {
              this._element.dropdown('handleClose');
            }, 10);
            break;

          case "Escape":
          case "Esc":
          case "Tab":
          case "Delete":
          case "Backspace":
            event.preventDefault();
            this._element.dropdown('handleClose');
            break;

          case "ArrowUp":
            event.preventDefault();
            var prevItem = event.target.previousElementSibling;
            if (prevItem) {
              prevItem.focus()
            } else {
              this._option[this._option.length - 1].focus();
            }
            break;

          case "ArrowDown":
            event.preventDefault();
            var nextItem = event.target.nextElementSibling;
            if (nextItem) {
              nextItem.focus()
            } else {
              this._option[0].focus();
            }
            break;

          case "Home":
            event.preventDefault();
            this._option[0].focus();
            break;

          case "End":
            event.preventDefault();
            this._option[this._option.length - 1].focus();
            break;

          default:
            this._searchQuery += event.key;

            const foundOption = this.findOption(this._searchQuery);

            if (foundOption) foundOption.focus();

            if (this._searchTimeout) clearTimeout(this._searchTimeout);

            this._searchTimeout = setTimeout(() => {
              this._searchQuery = '';
            }, 1000);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Trigger Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleTriggerKeydown = (event, details) => {
        const key = details.key;

        switch (key) {
          case "Escape":
          case "Esc":
          case "Delete":
          case "Backspace":
            if (!this._hasLinks) {
              event.preventDefault();
              this.handleReset();
            }
            break;
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.select = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].select = new Select(_[i], opt);
        else
          ret = _[i].select[opt].apply(_[i].select, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-select-custom').select();
});